import {
    AVALANCHE_C_CHAIN_ID,
    AVALANCHE_FUJI_CHAIN_ID,
    ETHEREUM_MAINNET_CHAIN_ID,
    SEPOLIA_CHAIN_ID,
} from '@/chains';

/**
 * Hardcoded wallet addresses granted /backoffice access per chain, in
 * addition to the on-chain checks (PrivacyPortalFactory isAdmin/isOperator
 * on PoD chains, bridge admin/operator roles on COTI chains).
 * On PoD, allowlisted wallets get full admin menu access.
 */
const TESTNET_BACKOFFICE_OPERATORS: Record<number, readonly string[]> = {
    [SEPOLIA_CHAIN_ID]: ['0xdF9F8FcA4591227C092FCBAb45A846C19fb6d1ae'],
    [AVALANCHE_FUJI_CHAIN_ID]: ['0xdF9F8FcA4591227C092FCBAb45A846C19fb6d1ae'],
};

/** Mainnet PoD deployments — owner from deployConfig.mainnet.yaml. */
const MAINNET_BACKOFFICE_OPERATORS: Record<number, readonly string[]> = {
    [AVALANCHE_C_CHAIN_ID]: ['0xdF9F8FcA4591227C092FCBAb45A846C19fb6d1ae'],
    [ETHEREUM_MAINNET_CHAIN_ID]: ['0xdF9F8FcA4591227C092FCBAb45A846C19fb6d1ae'],
};

export const isBackofficeOperator = (chainId: number, walletAddress: string): boolean => {
    const allowed =
        TESTNET_BACKOFFICE_OPERATORS[chainId]
        ?? MAINNET_BACKOFFICE_OPERATORS[chainId]
        ?? [];
    const normalized = walletAddress.toLowerCase();
    return allowed.some(address => address.toLowerCase() === normalized);
};
